import React from "react";
import NoDataInfographic from "./no-data-infographic.png";

import Grid from "@mui/material/Grid";
import { Typography } from "@mui/material";

const NoTableData = ({ fetchAllDataHandler }) => {
  const showAllDataCB = () => {
    fetchAllDataHandler();
    document
      .getElementById("totalLoanBeneficiary")
      .scrollIntoView({ behavior: "smooth" });
  };

  return (
    <Grid container direction="column">
      <Grid
        item
        style={{
          backgroundImage: `url(${NoDataInfographic})`,
          width: "100%",
          height: "13em",
          backgroundRepeat: "no-repeat",
          backgroundSize: "9rem",
          backgroundPosition: "center",
          marginTop: "3rem",
        }}
      ></Grid>
      <Grid
        item
        container
        style={{
          display: "flex",
          justifyContent: "center",
          marginTop: "2rem",
          flexDirection: "column",
        }}
      >
        <Grid item xs style={{ display: "flex", justifyContent: "center" }}>
          <Typography
            style={{
              width: "18rem",
              fontFamily: "Poppins",
              color: "#969393",
            }}
          >
            Make a search or apply a filter to show data
          </Typography>
        </Grid>
        <Grid item xs style={{ display: "flex", justifyContent: "center" }}>
          <Typography
            style={{
              color: "#969393",
              textDecoration: "underline",
              marginTop: "4rem",
              cursor: "pointer",
              fontSize: "13px",
              fontWeight: "100",
            }}
            onClick={showAllDataCB}
          >
            Show all data
          </Typography>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default NoTableData;
